module.exports = __webpack_public_path__ + "img/logo.d496b271.svg";